import { render, staticRenderFns } from "./CommonImg.vue?vue&type=template&id=66f18ddc&"
import script from "./CommonImg.vue?vue&type=script&lang=ts&"
export * from "./CommonImg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports